const STORAGE_KEY = 'sharedCategoryFilter';

export const getStoredCategoryId = (): string | null =>
  localStorage.getItem(STORAGE_KEY) || null;

export const storeSharedCategoryId = (categoryId: string | null): void => {
  if (categoryId) {
    localStorage.setItem(STORAGE_KEY, categoryId);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
};
